var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoodle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3750,
    height: 3750,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h3000v3000H0V0z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h3000v3000H0V0z",
    style: {
      fill: "#fff",
      fillOpacity: 0,
      fillRule: "nonzero",
      stroke: "none"
    },
    fill: "none",
    transform: "matrix(1.25 0 0 -1.25 0 3750)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.25 0 0 -1.25 0 3750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0s10.429-166.869-303.656-77.28c0 0-51.801-75.708 31.877-175.325 0 0-34.075-62.963 181.2-85.57 7.067-.743 28.461-4.673 37.075-10.7 37.331-26.123 115.427-116.967-113.365-342.936 0 0 428.027 13.523 451.936 316.357 0 0 13.782 228.022-285.067 375.454",
    style: {
      fill: "#f9c4db",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(966.738 2296.83)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s332.949 95.92 430.628 325.499l-14.151 26.281S185.999 72.782-68.738 60.652L0 0z",
    style: {
      fill: "#f9c4dc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(2237.658 1462.009)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s-134.655-223.154-73.344-464.997L.577-506.464S53.004-148.953 229.381 38.594L0 0z",
    style: {
      fill: "#f9c4db",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1831.94 1198.97)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-8.081-27.079 126.774-83.317 136.223-82.846C252.429-77.04 366.083 38.036 479.144 59.172c86.97 16.258 173.164 23.568 248.623-22.123 53.132-32.173 79.983-61.507 97.762-119.895 36.874-121.1-62.351-238.517-107.378-342.922-29.044-67.342-3.111-160.878 31.173-225.15 27.328-51.228 92.198-86.882 141.624-116.161 29.69-17.588 61.771-39.71 98.007-46.138l-53.885-75.196c-5.839-8.149-86.845 14.702-94.488 16.492-69.451 16.267-139.975 37.85-202.901 71.912C574.779-765.957 520.943-740.584 493-671.7c-25.462 62.767-31.188 148.042-37.654 213.866-1.443 14.679-5.119 27.419-12.183 35.946-11.771 14.209-32.947 16.718-68.85-3.002-10.943-6.009-50.863-42.082-75.678-67.517-80.376-82.383-276.514-247.37-495.049-165.747L0 0",
    style: {
      fill: "#f9c4db",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1523.862 1574.88)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s-101.868-325.976-213.921-427.843l74.702-74.704S125.637-213.922 173.175-27.165L0 0z",
    style: {
      fill: "#f9c4db",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(933.774 1120.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s-28.629-159.559-173.961-118.05c-12.083 3.451-40.105 38.168-33.108 60.256 6.996 22.09 22.375 42.83 55.899 37.431 0 0 31.251 1.844 48.641 88.467L0 0z",
    style: {
      fill: "#f9c4dc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(697.643 407.484)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s28.774-159.532-121.912-171.274c-12.529-.977-50.893 21.796-52.032 44.938-1.142 23.144 6.044 47.942 39.348 54.565 0 0 28.65 12.621 14.762 99.873L0 0z",
    style: {
      fill: "#f9c4dc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1775.81 493.46)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s-278.918-167.447-423.164-168.975l5.85-100.463s371.244 37.654 523.339 140.442L0 0z",
    style: {
      fill: "#f9c4db",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(930.713 1380.01)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s-114.957-103.098-199.826 13.202c-7.056 9.67-7.773 52.162 10.419 64.657 18.194 12.497 41.892 19.071 63.915-4.62 0 0 24.557-16.916 88.354 37.973L0 0z",
    style: {
      fill: "#f9c4dc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(298.086 1023.868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-49.918 21.865-97.547 49.717-140.508 83.291-82.178 64.217-154.203 155.337-151.787 265.428 1.061 48.391 6.034 108.931-56.149 118.919-87.186 14-191.531-109.283-256.204-150.679-113.19-72.449-234.873-125.155-368.602-142.008 218.178-80.844 413.894 83.8 494.161 166.072 24.816 25.436 64.735 61.508 75.678 67.518 35.903 19.72 57.079 17.211 68.85 3.002 7.064-8.527 10.741-21.268 12.183-35.946 6.466-65.825 12.192-151.099 37.654-213.867 27.944-68.883 81.78-94.256 144.681-128.308C-77.116-.641-6.593-22.224 62.858-38.49c4.866-1.141 39.462-10.814 65.472-15.592 5.944 7.135 9.536 11.443 9.537 11.444C127.414-55.181 13.875-6.074 0 0",
    style: {
      fill: "#ffabd9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(2301.586 741.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-25.92-17.899-46.931-39.979-46.931-22.079 0-39.978 21.011-39.978 46.931 0 25.919 17.899 46.932 39.978 46.932C-17.899 46.932 0 25.919 0 0",
    style: {
      fill: "#f175ae",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(719.502 2217.985)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-20.002-12.797-36.216-28.582-36.216-15.784 0-28.581 16.214-28.581 36.216 0 20 12.797 36.215 28.581 36.215C-12.797 36.215 0 20 0 0",
    style: {
      fill: "#f792c5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(703.453 2222.27)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-12.705-8.128-23.003-18.154-23.003S-36.308-12.705-36.308 0c0 12.703 8.128 23.002 18.154 23.002S0 12.703 0 0",
    style: {
      fill: "#f9c4db",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(690.22 2231.374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-10.103-50.386-152.304-37.951-251.337-22.916-.52-1.798-1.018-4.411-.91-7.62C33.484-76.201 0 0 0 0",
    style: {
      fill: "#e269a6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(945.252 2064.391)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s-4.323-60.534 70.624-24.501C70.624-24.501 8.648-41.797 0 0",
    style: {
      fill: "#e269a6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(935.406 2184.612)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.085-.297.207-.592.334-.901.704-1.691 2.574-2.835 4.324-1.767C9.895.526 21.053 5.348 23.594-9.534c.071-.413.372-.592.579.531C25.333-2.707 27.334 17.138 3.104 4.5 1.763 3.801.288 2.816-.06 1.263-.16.814-.114.405 0 0",
    style: {
      fill: "#e269a6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(930.84 2060.848)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s161.655 12.097 157.729-138.996c-.326-12.563-26.951-48.361-50.086-47.097-23.137 1.26-47.058 10.977-50.197 44.787 0 0-9.586 29.802-97.807 25.025L0 0z",
    style: {
      fill: "#f9c4dc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(2635.614 712.267)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-60.222-55.894-141.726-116.871-189.119-38.142-46.822-51.303-128.384 18.856-132.462 83.895-80.438 27.271-61.009 147.845 1.789 156.783-30.787 64.116 63.569 172.495 134.992 137.832 15.21 89.64 148.175 113.663 189.12 38.141 74.501 12.779 127.783-20.141 109.985-95.027 70.986-20.354 97.816-123.593 20.688-145.65C154.197 80.988 109.023-23.013 0 0",
    style: {
      fill: "#f175ae",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(571.453 954.364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-9.459-25.231-56.665-83.652-125.248-34.603-11.302-66.135-137.09-169.11-157.372 3.493-5.695-70.663-70.602-70.237-91.383-56.234-22.23 14.98-29.355 53.245-6.465 89.051-39.455-2.056-68.006-15.209-74.332 62.44-.621 30.236 48.53 58.117 75.753 61.992-31.473 37.704-22.173 67.307-4.783 90.536 22.469 30.014 82.286 50.266 111.917 18.854-1.974 40.26 33.408 102.515 104.072 96.818 22.626-7.805 54.495-34.893 16.837-113.51 38.594 64.954 74.819 89.983 119 59.478 19.883-16.409 28.18-37.286-2.527-87.933 54.291-.63 75.836-25.396 67.264-49.437-7.514-21.08-38.18-41.601-90.226-44.809C-20.621 68.271 11.327 30.213 0 0",
    style: {
      fill: "#fc95c9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(676.428 1025.37)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-6.752-18.013-28.28-76.25-120.662-9.272-8.068-47.215-97.87-120.73-112.35 2.493-4.067-50.447-50.404-50.142-65.24-40.146-15.871 10.693-20.958 38.012-4.615 63.575C-371.815-4.9-402.222-.823-406.738 54.613c-.443 21.585 40.428 38.887 104.884 50.87-45.995 28.976-57.052 66.858-44.637 83.444 16.04 21.427 99.968 17.077 121.123-5.348-1.41 28.742 23.85 73.187 74.297 69.119 16.154-5.573 38.905-24.91 12.02-81.037 27.553 46.373 72.972 91.218 104.514 69.439 14.195-11.715.561-53.593-21.361-89.753 38.759-.449 54.14-18.129 48.022-35.293-5.367-15.049-27.258-29.7-64.415-31.99C-45.966 64.171 8.087 21.569 0 0",
    style: {
      fill: "#ffabd9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(654.918 1040.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-29.37-76.733-75.594-167.423-152.868-117.695-19.373-66.701-123.526-39.743-155.89 16.818-84.217-11.028-119.997 105.742-67.592 141.479-55.923 43.946-19.088 182.843 60.301 183.259-25.915 87.151 82.796 167.392 152.87 117.695 61.212 44.348 123.553 38.324 140.634-36.729 72.68 13.064 142.321-67.734 82.846-121.566C102.623 140.729 107.987 27.469 0 0",
    style: {
      fill: "#f175ae",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(946.155 519.113)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c2.648-26.815-13.927-100.073-97.117-86.329 19.048-64.334-48.379-212.253-142.757-66.322 26.077-65.922-32.355-94.186-57.183-90.793-26.558 3.63-49.84 34.822-45.103 77.057-34.498-19.259-54.312-43.664-94.258 23.222-13.902 26.856 17.897 73.567 40.615 89.061-44.883 19.942-49.603 50.611-44.251 79.128 6.916 36.85 51.653 81.422 92.107 66.315-19.541 35.257-15.268 106.733 50.655 132.809 23.749 2.984 64.301-7.257 65.207-94.425 5.963 75.321 27.423 113.767 80.531 105.893 25.084-5.948 41.743-21.019 36.544-80.021 48.994 23.396 79.258 10.682 82.177-14.673 2.56-22.233-15.899-54.181-61.187-80.03C-48.636 52.16-3.17 32.11 0 0",
    style: {
      fill: "#fc95c9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1009.015 629.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.891-19.144 8.277-80.902-104.181-61.575 13.598-45.928-34.538-151.53-101.916-47.348 18.616-47.062-23.099-67.24-40.825-64.819-18.96 2.591-35.582 24.861-32.2 55.011-52.357-49.767-81.441-59.529-109.961-11.778-9.924 19.175 19.115 52.737 71.665 91.939-54.062 5.702-80.704 34.814-76.882 55.174 4.936 26.309 82.167 59.448 111.048 48.66-13.952 25.17-10.9 76.2 36.163 94.814 16.955 2.13 45.904-5.181 46.551-67.411 4.258 53.772 25.222 114.058 63.137 108.437 17.907-4.248 24.158-47.843 20.445-89.966 34.978 16.703 56.583 7.627 58.668-10.475 1.827-15.873-11.352-38.682-43.682-57.136C-69.569 37.295-2.262 22.923 0 0",
    style: {
      fill: "#ffabd9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(982.842 633.634)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c9.304-70.06 11.6-157.587-67.228-151.726 12.744-58.372-77.052-80.757-124.736-51.292-59.13-42.914-134.117 30.662-109.178 79.189-60.314 10.258-89.499 130.369-29.662 163.279-55.37 55.235-6.143 160.521 67.229 151.725 28.059 58.654 77.655 79.697 121.38 29.98 49.575 39.714 135.387 7.235 112.534-57.877C19.79 148.508 70.347 65.099 0 0",
    style: {
      fill: "#f175ae",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1940.925 640.73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c13.013-19.182 30.562-81.361-37.962-105.127 40.81-40.807 50.574-180.298-80.677-108.743 46.776-39.122 14.214-84.478-5.946-92.106-21.565-8.161-51.97 5.858-65.728 39.727-18.169-28.722-23.127-55.303-80.783-21.147-21.535 14.592-16.676 62.956-5.866 83.996-42.113-3.355-58.272 17.889-65.935 41.642-9.903 30.694 5.614 82.752 42.393 87.941-29.246 18.626-55.362 74.409-16.24 121.184 16.728 12.005 51.585 20.915 88.058-44.601-26.417 59.38-25.982 97.253 17.394 113.106 21.402 5.803 40.185 1.25 60.477-45.482 27.428 37.801 55.523 40.616 68.141 22.648 11.061-15.754 10.226-47.482-13.391-85.613C-58.177 19.458-15.578 22.971 0 0",
    style: {
      fill: "#fc95c9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1943.256 749.719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c9.291-13.694 39.473-57.754-53.468-89.317 29.137-29.132 36.109-128.718-57.594-77.633 33.394-27.931 10.145-60.309-4.246-65.756-15.394-5.826-37.102 4.182-46.924 28.361-19.144-59.115-37.12-78.434-78.282-54.051-15.375 10.419-7.203 47.71 16.422 98.919-43.205-17.887-75.295-6.82-80.765 10.14-7.071 21.911 37.701 78.668 63.959 82.371-20.878 13.298-39.525 53.123-11.593 86.516 11.94 8.571 36.826 14.931 62.862-31.841-18.858 42.393-27.764 96.568 3.204 107.886 15.28 4.142 37.904-26.244 52.391-59.609 19.582 26.988 39.638 28.996 48.646 16.171 7.899-11.249 7.302-33.899-9.559-61.121C-67.898-.373-11.121 16.397 0 0",
    style: {
      fill: "#ffabd9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1921.637 742.356)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c79.906-19.127 175.842-53.146 136.6-136.24 68.655-10.52 55.493-117.297 3.626-156.753 21.904-82.062-89.213-132.743-131.472-85.44-36.287-61.17-178.799-42.736-189.551 35.921-83.033-37.042-176.748 60.295-136.598 136.241-51.943 54.917-54.089 117.513 18.101 144.22-22.419 70.363 48.623 149.931 109.742 97.975C-152.894 83.423-41.298 103.489 0 0",
    style: {
      fill: "#f175ae",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(2505.795 953.054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c26.242 6.115 101.034-.777 98.239-85.05 61.308 27.264 216.747-20.325 84.351-132.902 61.965 34.438 97.597-19.815 97.466-44.872-.139-26.806-28.035-53.952-70.527-54.757 23.587-31.694 50.367-48.162-10.75-96.479-24.817-17.282-75.273 8.165-93.591 28.67-13.927-47.097-43.72-55.769-72.694-54.177-37.435 2.057-87.456 40.609-77.743 82.685-32.411-23.965-103.836-29.036-138.274 32.929-6.051 23.158-1.177 64.699 85.129 76.949-75.456-3.895-116.371 12.374-115.48 66.058 2.632 25.643 15.406 44.123 74.58 46.651-29.577 45.53-20.912 77.191 3.849 83.388 21.706 5.432 55.79-8.709 87.316-50.243C-45.382-55.018-31.425-7.326 0 0",
    style: {
      fill: "#fc95c9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(2388.501 1001.049)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c18.735 4.369 79.136 18.742 74.619-95.274 43.767 19.463 154.737-14.512 60.216-94.883 44.238 24.586 69.678-14.146 69.584-32.034-.1-19.138-20.015-38.519-50.35-39.093 56.162-45.429 69.629-72.994 25.999-107.488-17.718-12.338-54.778 12.084-100.489 59.081 1.389-54.345-24.007-84.55-44.693-83.414-26.726 1.469-69.64 73.727-62.707 103.765-23.138-17.109-74.13-20.73-98.715 23.509-4.319 16.533-.842 46.187 60.773 54.933-53.867-2.781-116.371 10.154-115.732 48.479 1.876 18.308 44.288 30.181 86.535 31.985-21.116 32.505-14.931 55.109 2.746 59.534 15.498 3.878 39.83-6.217 62.337-35.871C-27.917-73.832-22.433-5.228 0 0",
    style: {
      fill: "#ffabd9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(2387.472 974.515)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-29.594-61.478-74.283-130.996-136.361-64.891-20.529-55.118-106.716-2.305-130.473 57.74-71.746 12.978-94.606 128.474-48.151 146.546-44.425 55.045-4.634 170.778 62.374 149.507-16.397 85.985 80.361 129.002 136.362 64.89C-61.819 377.258-9.6 354.804.104 282.183c62.142-7.99 115.828-100.147 62.271-132.677C95.414 99.451 92.834-4.574 0 0",
    style: {
      fill: "#f175ae",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(2827.4 1727.887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.551-25.005-18.027-86.822-87.354-51.689 12.033-63.453-54.136-179.013-124.609-21.132 17.866-66.805-33.207-76.466-53.941-66.623-22.179 10.529-39.867 45.126-33.222 82.078-30.312-8.032-48.563-24.729-78.067 46.733-10.045 28.112 19.714 61.739 39.853 69.573-36.616 30.298-38.675 59.357-32.369 83.723 8.146 31.483 48.689 59.647 81.872 34.933-14.275 37.253-6.185 100.815 51.071 106.451 20.222-3.776 53.795-24.107 49.092-103.289 9.755 66.581 30.276 95.545 74.59 73.932 20.791-12.227 33.899-30.418 25.813-82.429 42.802 7.826 67.539-11.939 68.414-35.697.761-20.828-16.817-44.727-56.648-55.784C-37.762 60.497-.66 29.941 0 0",
    style: {
      fill: "#fc95c9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(2887.34 1810.396)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.395-17.852 1.907-75.518-91.763-27.35 8.591-45.297-38.647-127.799-88.96-15.085 12.756-47.693-23.706-54.588-38.508-47.564-15.835 7.52-28.462 32.217-23.718 58.599-47.296-30.79-72.447-31.698-93.514 19.318-7.172 20.071 19.435 42.545 66.233 63.713-45.254 19.905-65.907 53.534-61.405 70.929 5.815 22.477 73.056 31.425 96.745 13.781-10.192 26.597-4.417 71.975 36.459 75.996 14.441-2.694 38.406-17.209 35.046-73.736 6.966 47.531 28.438 96.405 60.074 80.976 14.844-8.73 17.381-49.912 11.606-87.044 30.559 5.588 48.22-8.523 48.842-25.485.546-14.87-12.004-31.93-40.44-39.824C-56.355 52.743-.47 21.375 0 0",
    style: {
      fill: "#ffabd9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(2865.54 1821.586)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s-232.047-392.03 126.833-285.375c0 0 16.781-82.157 68.126 6.271 0 0 87.44 250.58-194.959 279.104",
    style: {
      fill: "#f175ae",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(906.575 2524.982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s-29.425-11.847-82.753 27.068c-40.145 29.297-51.861 76.612-51.524 107.37.363 33.099 3.335 65.42 3.335 65.42s-218.159 76.971-151.617 244.656C-196.413 661.601-58.58 578.901-58.58 578.901s42.506 101.337 201.624 44.855c136.069-48.3 115.394-144.783 115.394-144.783s94.838 63.22 217.087-48.244c117.16-106.82 68.918-206.75 68.918-206.75s99.929 0 161.954-106.82c52.31-90.091-13.784-165.4-13.784-165.4s79.125-38.804 106.822-141.28c34.458-127.496-31.012-196.413-31.012-196.413s50.207-98.327 31.012-186.075c-24.122-110.267-151.617-144.725-151.617-144.725s61.578-89.412 44.795-182.63c-15.906-88.359-179.183-93.037-179.183-93.037s-7.667-177.423-134.387-234.318c-168.847-75.808-306.681 82.7-306.681 82.7s-99.488-64.755-244.654 24.122c-168.846 103.375-86.146 272.221-86.146 272.221s-161.955 58.579-120.604 237.763c1.264 5.481 28.205 77.492 103.375 130.941 63.22 44.954 172.553-29.027 172.553-29.027s-188.802 202.862 257.093 148.632c0 0-226.965-10.043-205.11 130.436C-42.407-172.854 0 0 0 0",
    style: {
      fill: "#f175ae",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1117.603 2124.62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-45.444 98.905 100.801 149.909 100.801 149.909s-162.833 41.354-90.462 170.586c22.49 40.161 136.985 124.062 193.848-31.016 0 0 23.26 219.699 170.585 126.646 0 0 160.248-100.795-25.846-232.611 0 0 211.226 132.997 314.064 65.303 11.664-7.679 22.534-17.274 32.278-29.123 0 0 134.401-136.986-54.278-222.278 0 0 245.541 46.528 273.971-74.949 0 0 23.263-126.647-297.232-162.832 0 0 286.894 38.77 367.018-82.708 35.67-54.078 77.539-219.695-162.833-250.711 0 0 328.251-191.27-12.923-284.316 0 0 131.818-103.378 51.694-201.596-26.977-33.065-142.156-87.876-279.141 23.264 0 0 261.048-168.002 18.092-312.742-46.468-27.684-297.233-31.016-248.126 258.464 0 0-87.877-307.572-294.648-116.316 0 0-157.663 175.761 170.585 304.993 0 0-325.664-87.878-309.135 78.09 1.532 15.377 6.685 32.302 14.487 51.135 0 0 10.177 25.08 32.848 51.113 37.786 43.389 130.751 64.088 248.676 1.087 0 0-263.117 196.836 166.708 196.836 0 0-33.291 12.595-104.444 42.179-78.348 32.576-58.247 186.793 15.476 365.284 0 0-258.463-31.017-100.8 155.078C191.263 38.769 43.939-95.633 0 0",
    style: {
      fill: "#fc95c9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(874.482 2289.025)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-89.288.001-156.838 61.162-165.769 149.436-2.421 23.936 42.56 156.26-5.541 146.981-30.963-6.001-59.59-115.896-74.034-138.763-34.538-54.677-96.695-83.541-157.374-54.326-53.442 25.732-95.865 89.946-81.102 151.424 6.239 25.977 22.256 51.046 47.603 74.517 27.049 25.046 59.759 41.848 92.521 57.957 40.717 20.02 65.2 57.27-1.857 55.066-40.855-1.34-80.828-13.813-122.353-13.817-51.685-.003-88.141 10.108-105.435 29.24-40.714 45.038 27.524 109.588 62.104 141.378 72.397 66.556 164.957-20.298 237.484-53.551-15.898 7.289-67.641 130.446-62.247 143.934 32.1 80.248 354.315 120.066 311.566 132.41-61.193-9.599-132.898-6.295-173.078 11.716-94.181 42.217-117.683 165.235-9.801 392.252-60.476-10.756-111.43-4.139-121.345-2.064-69.394 14.525-27.67 71.678-2.424 110.986 5.598 8.714 42.705 65.186 10.746 60.582-56.409-8.159-80.267-81.831-135.271-91.965-32.483-5.986-52.9 12.317-53.76 43.616-1.001 36.458 20.36 60.452 50.387 78.574 20.379 12.298 38.013 18.521 38.188 18.58l65.852 23.012-67.57 17.485c-.67.173-67.369 17.887-86.18 61.995-8.958 21.012-5.383 46.188 10.623 74.831 9.458 16.916 43.7 47.139 78.264 47.139 30.757 0 111.125-138.225 111.125-138.225.039.348 7.253 103.672 20.861 137.314 15.802 39.055 45.648 71.093 89.455 55.989 39.521-13.628 80.092-53.9 81.168-97.772.383-15.663-4.61-31.878-14.842-48.201-12.584-20.075-43.134-34.375-51.016-56.631-26.047-73.553 87.2-1.535 106.385 6.857 50.553 22.11 117.5 44.989 171.551 22.793 49.447-20.304 94.215-78.197 83.661-133.913-6.998-36.728-83.681-60.339-81.39-93.361 3.631-52.017 326.34 12.928 241.321-122.257-23.779-37.811-76.309-56.347-116.384-69.65-21.856-7.255-44.137-13.171-66.472-18.743-.009-.001-.017 0-.026-.01-14.558-3.622-97.25-16.644-61.509-44.958 17.394-13.778 63.48-2.711 84.84-2.711 87.648 0 216.933-5.589 255.78-101.395 65.188-160.774-161.971-199.766-270.745-201.679 74.89 1.318 315.584-165.055 204.889-232.827-114.085-69.849-202.464-30.256-202.56-30.267 6.971.899 38.248-31.298 44.327-36.046 21.567-16.847 43.719-33.216 63.649-52.03 29.593-27.936 69.301-78.056 35.144-117.551-20.546-23.758-73.177-39.331-103.404-39.334h-.068c-36.34.043-193.812 83.379-230.565 81.982-47.044-1.795 86.152-81.801 102.443-104.773 25.704-36.246 71.893-75.926 62.126-123.742-9.085-44.478-52.449-76.77-89.119-98.657C45.712 5.774 28.522.006.05 0H0z",
    style: {
      fill: "#ffabd9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1406.485 973.495)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s430.309-457.458-47.723-447.415c0 0 403.716-12.051 47.723 447.415",
    style: {
      fill: "#f175ae",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(1275.117 2212.668)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M-5186.659 1952.14V82.886h3747.242v3738.508h-3747.242V1952.14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M-5186.659 1952.14V82.886h3747.242v3738.508h-3747.242V1952.14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M-5186.659 1952.14V82.886h3747.242v3738.508h-3747.242V1952.14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M-5186.659 1952.14V82.886h3747.242v3738.508h-3747.242V1952.14zM1.7 1873.526V4.273H3748.944V3742.78H1.701V1873.526z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M1.7 1873.526V4.273H3748.944V3742.78H1.701V1873.526z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M1.7 1873.526V4.273H3748.944V3742.78H1.701V1873.526z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M1.7 1873.526V4.273H3748.944V3742.78H1.701V1873.526z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoodle);
export default __webpack_public_path__ + "static/media/poodle.fbeb678847033f04824e89cbd77276b2.svg";
export { ForwardRef as ReactComponent };